import { BudgetUseExtendedClient } from '@frontend/budget/api';
import { BudgetUseExtended } from '@frontend/budget/types';
import { EntityType } from '@frontend/common';
import { accountIdFromResolvedEntity } from '@frontend/components/common';
import { defaultCellClassName } from '@frontend/components/list';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { CommonMessage } from '@frontend/lang';

import { PlatformObjectBadge } from '../../../modal/platform-object-badge/platform-object-badge.component';
import { useAppDispatch } from '../../../redux/store';
import OverviewHeader from '../../header/overview-header';

const ID = 'budget-use-overview';

export const BudgetUse = () => {
    const dispatch = useAppDispatch();

    return (
        <div className='size-lf-stretch bg-background-default inline-flex w-full flex-col items-start justify-start gap-6'>
            <OverviewHeader
                title={
                    <div className='flex gap-2'>
                        <span>{CommonMessage.OBJECTS.BUDGET.PLURAL}</span>
                        <span>/</span>
                        <span>{CommonMessage.OBJECTS.USE.PLURAL}</span>
                    </div>
                }
            />
            <ReactiveObjectList<BudgetUseExtended>
                id={ID}
                type={EntityType.BUDGET_USE}
                activeFilter={{ searchKeys: ['user', 'product'] }}
                dispatch={dispatch}
                fetch={(arg) => BudgetUseExtendedClient.fetchExtendedBudgetUses(arg)}
                columns={{
                    columns: ['user', 'budget', 'product', 'quantity', 'creation_timestamp'],
                    headerOverwrite: new Map([
                        ['user', CommonMessage.OBJECTS.USER.DEFAULT],
                        ['budget', CommonMessage.OBJECTS.BUDGET.DEFAULT],
                        ['product', CommonMessage.OBJECTS.PRODUCT.DEFAULT]
                    ]),
                    customCells: new Map([
                        [
                            'user',
                            (obj) => (
                                <td className={defaultCellClassName}>
                                    {obj.row.original.user ? (
                                        <PlatformObjectBadge
                                            id={obj.row.original.user.entity_id}
                                            entityType={obj.row.original.user.entity_type}
                                            display={obj.row.original.user.name}
                                            foreign={obj.row.original.user.foreign}
                                            accountId={accountIdFromResolvedEntity(obj.row.original.user)}
                                        />
                                    ) : (
                                        '/'
                                    )}
                                </td>
                            )
                        ],
                        [
                            'budget',
                            (obj) => (
                                <td className={defaultCellClassName}>
                                    {obj.row.original.budget ? (
                                        <PlatformObjectBadge
                                            id={obj.row.original.budget.entity_id}
                                            entityType={obj.row.original.budget.entity_type}
                                            display={obj.row.original.budget.name}
                                            foreign={obj.row.original.budget.foreign}
                                            accountId={accountIdFromResolvedEntity(obj.row.original.budget)}
                                        />
                                    ) : (
                                        '/'
                                    )}
                                </td>
                            )
                        ],
                        [
                            'product',
                            (obj) => (
                                <td className={defaultCellClassName}>
                                    {obj.row.original.product ? (
                                        <PlatformObjectBadge
                                            id={obj.row.original.product.entity_id}
                                            entityType={obj.row.original.product.entity_type}
                                            display={obj.row.original.product.name}
                                            foreign={obj.row.original.product.foreign}
                                            accountId={accountIdFromResolvedEntity(obj.row.original.product)}
                                        />
                                    ) : (
                                        '/'
                                    )}
                                </td>
                            )
                        ]
                    ])
                }}
                sortingColumns={['creation_timestamp']}
                filter={{ default: true }}
                showCount
            />
        </div>
    );
};
